import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
// inspections list
import { ChildrenInspectionListComponent } from '../components/children-list.component';

// inspection detail
import { InspectionDetailPageComponent } from '../pages/detail.component';
import { InspectionDetailComponent } from '../components/detail.component';

// views
import { InspectionViewPageComponent } from '../pages/view.component';
import { InspectionViewComponent } from '../components/view.component';

// validators
import { InspectionValidationPageComponent } from '../pages/validation.component';
import { InspectionValidationComponent } from '../components/validations.component';

// reports
import { InspectionReportPdfListPageComponent } from '../pages/report-pdf-list.component';

import { routedComponents, InspectionsRoutingModule } from './inspection.routing';

// menus
import { InspectionMenuComponent } from '../../menus/inspection.menu';
import { InspectionRestoreListMenuComponent } from '../../menus/restore-list.menu';
import { ManagerInspectionListMenuComponent } from '../../menus/manager-inspection-list.menu';

// select model from machine
import { MachineSelectorPageComponent } from '../pages/machineSelector.component';

// admin pages (ported from manager)
import { ManagerInspectionListPageComponent } from '../pages/admin-list.component';
import { ManagerInspectionListComponent } from '../components/admin-list.component';
import { ManagerInstallationListComponent } from '../components/admin-installation-list.component';
import { InspectionStatusPageComponent } from '../pages/status.component';

import { PluginModule } from '../../plugins/modules';
import { SharedModule } from '../../shared.module';
import { InspectionRestoreListComponent } from '../components/restore-list.component';
import { ChildrenInspectionListMenuComponent } from '../../menus/children-inspection-list.menu';

@NgModule({
  imports: [PluginModule, SharedModule, CommonModule, InspectionsRoutingModule, FormsModule, ReactiveFormsModule],
  declarations: [
    routedComponents,
    InspectionDetailPageComponent,
    InspectionViewPageComponent,
    InspectionValidationPageComponent,
    InspectionViewComponent,
    InspectionValidationComponent,
    InspectionMenuComponent,
    InspectionDetailComponent,
    InspectionReportPdfListPageComponent,
    MachineSelectorPageComponent,
    InspectionRestoreListComponent,
    InspectionRestoreListMenuComponent,
    ChildrenInspectionListMenuComponent,
    ChildrenInspectionListComponent,
    ManagerInspectionListPageComponent,
    ManagerInspectionListComponent,
    ManagerInstallationListComponent,
    ManagerInspectionListMenuComponent,
    InspectionStatusPageComponent
  ]
})
export class InspectionModule {}
